//Returns an array of content tags or an empty array if none
function getPageContentTags() {
    //Note(JD): Specifically this returns an array wrapped in a jquery object without the "get()" on the end, we want a simple array because we are sticking this in local storage!
    return $("meta[property=content_tag]").map(function () {
        return $(this).prop("content");
    }).get();
}

$(document).ready(function () {
    initQuestionnaires();
    displaySectionsBasedOnUserProfileContentTags();
});

function initQuestionnaires() {
    //Prepop needs to happen before we bind events, otherwise we might bind an event to an input, then update that input, causing the event to trigger
    prePopQuestionsFromUserContentTags();

    $(".js-questionnaire-save-button").on("click", function (e) {
        updateUserContentTags($(this));
        displaySectionsBasedOnUserProfileContentTags();
    });

    $(".js-questionnaire-question-select").change(function() {
        var parent_questionnaire_container = $(this).closest(".js-questionnaire-container");
        var questionnaire_update_method = parent_questionnaire_container.data("update-method");
        if(questionnaire_update_method === "auto") {
            updateUserContentTags($(this));
            displaySectionsBasedOnUserProfileContentTags();
        }
    });

    $(".js-questionnaire-cancel").on("click", function (e) {
        e.preventDefault();
        saveUserProfileQuestionnaireTags([]);
        displaySectionsBasedOnUserProfileContentTags();
    });
}

function prePopQuestionsFromUserContentTags() {
    var user_profile_content_tags = getUserProfileQuestionnaireTags();
    var all_questions_on_page = $(".js-question-container");
    if(user_profile_content_tags && all_questions_on_page.length) {
        for(var key in user_profile_content_tags) {
            var content_tag_id = key;
            var content_tag_path = user_profile_content_tags[key].path;
            var matching_questions = all_questions_on_page.filter("[data-question-id='"+content_tag_id+"']");
            //Shouldn't be more than one of the same id...but ya never know...
            matching_questions.each(function(){
                var current_question = $(this);
                if(current_question.data("question-type") === "select") {
                    var current_question_element_id = current_question.data("question-unique-id");
                    $("#"+current_question_element_id).val(content_tag_path).change();
                }
            });
        }
    }
}

function UserProfileContentTag(tagPath, tagTitle, questionType, profileType) {
    this.path = tagPath;
    this.title = tagTitle;
    this.questionType = questionType;
    this.type = profileType;
}

function updateUserContentTags(triggering_element) {
    var user_profile_content_tags = getUserProfileQuestionnaireTags();
    var parent_questionnaire_container = triggering_element.closest(".js-questionnaire-container");
    var parent_questionnaire_type = parent_questionnaire_container.data("profile-type");
    var questions = parent_questionnaire_container.find(".js-question-container");
    questions.each(function (index) {
        var current_question = $(this);
        var current_question_type = current_question.data("question-type");
        var current_question_id = current_question.data("question-id");
        var current_question_element_id = current_question.data("question-unique-id");
        var current_question_answer_text = "";
        var current_question_answer_value = "";

        //NOTE(JD) - If we plan to support several different types of question, then the selectors might be quite different.
        if(current_question_type === "select") {
            var current_question_selected_option = $("#"+current_question_element_id).find("option:selected");
            current_question_answer_text = current_question_selected_option.text().trim();
            current_question_answer_value = current_question_selected_option.val();
        }

        if(current_question_id) {
            if(current_question_answer_value) {
                user_profile_content_tags[current_question_id] = new UserProfileContentTag(current_question_answer_value, current_question_answer_text, current_question_type, parent_questionnaire_type);
            } else {
                delete user_profile_content_tags[current_question_id];
            }
        }
    });
    saveUserProfileQuestionnaireTags(user_profile_content_tags);
}

function displaySectionsBasedOnUserProfileContentTags() {
    var NO_TAGS_MODE = "noTags";
    var MATCH_TAGS_MODE = "matchTags";
    var EXCLUDE_TAGS_MODE = "excludeTags";
    var user_content_tags = getUserProfileContentTags();
    var is_authoring = $('.aem_author_mode').length > 0;
    var all_content_tag_sections = $(".content_tag_section");
    if(is_authoring) {
        all_content_tag_sections.show();
    } else {
        all_content_tag_sections.each(function (index) {
            var current_section = $(this);
            var current_section_content_tag_mode = current_section.data("content-tag-mode");
            var current_section_content_tags = current_section.data("content-tags");

            switch (current_section_content_tag_mode) {
                case NO_TAGS_MODE:
                    if(user_content_tags.length === 0) {
                        current_section.fadeIn();
                    } else {
                        current_section.hide();
                    }
                    break;
                case MATCH_TAGS_MODE:
                    current_section_content_tags = current_section_content_tags.split(",");
                    if(user_content_tags.length) {
                        var tag_match_found = false;
                        for (var i = 0; i < user_content_tags.length; i++) {
                            if (current_section_content_tags.indexOf(user_content_tags[i]) !== -1) {
                                tag_match_found = true;
                                break;
                            }
                        }

                        if (tag_match_found) {
                            current_section.fadeIn();
                        } else {
                            current_section.hide();
                        }
                    } else {
                        current_section.hide();
                    }
                    break;
                case EXCLUDE_TAGS_MODE:
                    current_section_content_tags = current_section_content_tags.split(",");
                    if(user_content_tags.length) {
                        //We want to check to make sure the user (does not) have any matching tags
                        var exclude_tag_match_found = false;
                        for (var i = 0; i < user_content_tags.length; i++) {
                            if (current_section_content_tags.indexOf(user_content_tags[i]) !== -1) {
                                exclude_tag_match_found = true;
                                break;
                            }
                        }

                        if(exclude_tag_match_found) {
                            current_section.hide();
                        } else {
                            current_section.fadeIn();
                        }
                    } else {
                        current_section.hide();
                    }
                    break;
                default:
                    current_section.hide();
                    console.log('WARNING: NO MATCH FOR MODE',current_section_content_tag_mode,"section",current_section);
            }
        });
    }
}
